export class SliderManager {
    constructor() {
        this.initSliders();
    }

    initSliders() {
        const self = this;
        const logosResponsive = [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 360,
                settings: {
                    slidesToShow: 1
                }
            }
        ];
        const postsResponsive = [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ];

        $( '.hero-slider' ).each( function() {
            let $this = $( this );

            self.initSlider( $this, '.slider-inner', 1, null, true, 10000, true );
        } );

        $( '.logo-slider' ).each( function() {
            let $this = $( this );

            self.initSlider( $this, '.logos', 7, logosResponsive );
        } );

        $( '.posts-slider' ).each( function() {
            let $this = $( this );

            self.initSlider( $this, '.posts', 5, postsResponsive );
        } );
    }

    initSlider( $el, innerSelector, slidesToShow, responsiveArgs, autoplay = false, speed = 5000, dots = false ) {
        let $inner = $el.find( innerSelector ),
            $customArrows = $el.find( '.custom-arrows' ),
            $arrowLeft = $customArrows.find( '.arrow-left' ),
            $arrowRight = $customArrows.find( '.arrow-right' );

        $inner.slick( {
            dots: dots,
            infinite: autoplay,
            prevArrow: $arrowLeft,
            nextArrow: $arrowRight,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            responsive: responsiveArgs,
            autoplay: autoplay,
            autoplaySpeed: speed
        } );
    }
}
